import React from 'react';
import Icon from '../../../components/AppIcon';

const MenuHero = () => {
  return (
    <section className="relative bg-gradient-to-br from-primary/10 via-secondary/5 to-background py-12 md:py-16 lg:py-20 overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-10 left-10 w-32 h-32 bg-primary rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 right-10 w-40 h-40 bg-secondary rounded-full blur-3xl"></div>
      </div>
      
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 relative z-10">
        <div className="text-center space-y-4 md:space-y-6">
          <div className="inline-flex items-center gap-2 bg-primary/10 px-4 py-2 rounded-full">
            <div className="w-5 h-5 overflow-hidden rounded-full">
              <img src="/assets/images/logo-1767562373802.jpeg" alt="Chapati Plus Logo" className="w-full h-full object-contain" />
            </div>
            <span className="text-primary font-semibold text-sm md:text-base">Fresh Daily Menu</span>
          </div>
          
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground">
            Discover Our Delicious Menu
          </h1>
          
          <p className="text-base md:text-lg lg:text-xl text-muted-foreground max-w-2xl mx-auto">
            Authentic South Sudanese flavors crafted with fresh ingredients. Every dish tells a story of tradition and quality.
          </p>
          
          <div className="flex flex-wrap items-center justify-center gap-3 md:gap-4 pt-4">
            <div className="flex items-center gap-2 text-sm md:text-base text-muted-foreground">
              <Icon name="Clock" size={18} color="var(--color-accent)" />
              <span>Fresh Daily</span>
            </div>
            <div className="w-1 h-1 bg-muted-foreground rounded-full"></div>
            <div className="flex items-center gap-2 text-sm md:text-base text-muted-foreground">
              <Icon name="Leaf" size={18} color="var(--color-accent)" />
              <span>Quality Ingredients</span>
            </div>
            <div className="w-1 h-1 bg-muted-foreground rounded-full"></div>
            <div className="flex items-center gap-2 text-sm md:text-base text-muted-foreground">
              <Icon name="Award" size={18} color="var(--color-accent)" />
              <span>Local Favorite</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MenuHero;